import { createTypes } from "./createTypes";

export default createTypes(
  "GET_NEW_CLUES_AVAILABLE",
  "GET_DASHBOARD_WATCH",
  "GET_DASHBOARD_PRIZES",
  "GET_DASHBOARD_ANNOUNCEMENTS",
  "GET_DASHBOARD_ENGAGEMENTS"
);
